import PropTypes from "prop-types";

import { useEffect } from "react";

import Header from "../Components/Header/Header";
import Footer from "../Components/Footer/Footer";

function LayoutContainer({ children }) {
  useEffect(() => {
    import("../js/app");
  }, []);
  return (
    <section className="body-bg sublayout-landing">
      <Header />

      {children}

      <Footer />
    </section>
  );
}

LayoutContainer.propTypes = {
  children: PropTypes.node.isRequired,
};

export default LayoutContainer;
